import { UTM_PARAMS } from "./constants";
import type { UtmParams } from "./types";

// Mirror the click-id cap so a single oversized param can't bloat the handoff.
const MAX_UTM_LENGTH = 200;

function normalizeUtmValue(value: string | null | undefined) {
  const trimmed = value?.trim();
  if (!trimmed || trimmed.length > MAX_UTM_LENGTH) {
    return undefined;
  }
  return trimmed;
}

export function parseUtmParamsFromSearch(search: string): UtmParams | null {
  const params = new URLSearchParams(
    search.startsWith("?") ? search.slice(1) : search,
  );

  const result: UtmParams = {};
  for (const key of UTM_PARAMS) {
    const value = normalizeUtmValue(params.get(key));
    if (value) {
      result[key] = value;
    }
  }

  return Object.keys(result).length > 0 ? result : null;
}
